import styled from 'styled-components';

export const LoaderContainer = styled.div`
  backdrop-filter: blur(2.5px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.layers.topLayer + 1};
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(45, 45, 45, 0.3);
`;
